"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Radiator(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M18 3c.524 0 1.047.18 1.328.54.49.625 1.003 1.284 1.33 1.702.226.288.342.608.342.934V18.1c0 .379-.16.75-.46 1.072l-1.27 1.357c-.294.314-.782.471-1.27.471s-.976-.157-1.271-.47L16 19.75l-.73.78c-.294.313-.782.47-1.27.47s-.976-.157-1.271-.47L12 19.75l-.73.78c-.294.313-.782.47-1.27.47s-.976-.157-1.271-.47l-1.27-1.358C7.159 18.85 7 18.479 7 18.1V17H5a1 1 0 0 1 0-2h2v-5H4.437A1.507 1.507 0 0 1 3 8.5 1.496 1.496 0 0 1 5.908 8H7V6.176c0-.325.119-.647.344-.936l1.328-1.7C8.952 3.18 9.476 3 10 3s1.047.18 1.328.54L12 4.4l.672-.86c.28-.36.804-.54 1.328-.54s1.047.18 1.328.54L16 4.4l.672-.86c.28-.36.804-.54 1.328-.54zm-8 2.088l-1 1.28V17.89l1 1.068 1-1.068V6.367l-.803-1.025L10 5.088zm4 0l-1 1.28V17.89l1 1.068 1-1.068V6.367l-.803-1.025L14 5.088zm4 0l-1 1.28V17.89l1 1.068 1-1.068V6.367l-.803-1.025L18 5.088z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Radiator;
